import { render, staticRenderFns } from "./SelectRoom.vue?vue&type=template&id=20a04934&scoped=true&"
import script from "./SelectRoom.vue?vue&type=script&lang=js&"
export * from "./SelectRoom.vue?vue&type=script&lang=js&"
import style0 from "./SelectRoom.vue?vue&type=style&index=0&id=20a04934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a04934",
  null
  
)

export default component.exports